import React from 'react';

import { DateTime } from 'luxon';
import { useTriageDecisionWidgetQuery } from 'generated/graphql';



export interface ITriageDecision {
  createdAt: DateTime;
  outboundImei: string;
  workflowName: string;
  technicianFullName: string;
  repairCode: string;
  technicianComment: string;
}

export interface IData {
  triageDecision: ITriageDecision | null;
}

export function useQuery(returnAuthorizationId: string) {
  const tuple = useTriageDecisionWidgetQuery({
    variables: {
      returnAuthorizationId
    }
  });

  return React.useMemo(
    () => {
      const selectedTriage = tuple.data?.tier1ReturnAuthorization?.selectedTriage;
      const data: IData = {
        triageDecision: selectedTriage ? {
          workflowName: selectedTriage?.workflow.type.displayName ?? '',
          outboundImei: selectedTriage?.replacementSerialNumber || 'N/A',
          technicianFullName: selectedTriage?.createdBy.fullName ?? '',
          repairCode: selectedTriage.repairCode || 'N/A',
          technicianComment: selectedTriage.technicianComment ?? '',
          createdAt: DateTime.fromISO(selectedTriage.createdTimestamp)
        } : null
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
